import React, { useState, useEffect } from 'react';
import DataTable from '../DataTable';
import { getPackages, getProcessedDocuments, splitPackage } from '../../utils/api';
import { useDocument } from '../../utils/DocumentContext';
import WindowProducts from '../Windows/WindowProducts';
import WindowPrint from '../Windows/WindowPrint';

export default function DataPacketsSection() {
  const [packagesData, setPackagesData] = useState([]);
  const [rawPackages, setRawPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [expandedPackages, setExpandedPackages] = useState(new Set());  const [showProductsWindow, setShowProductsWindow] = useState(false);
  const [selectedDocumentForProducts, setSelectedDocumentForProducts] = useState(null);
  
  // Стани для вікна друку
  const [showPrintWindow, setShowPrintWindow] = useState(false);
  const [printDocument, setPrintDocument] = useState(null);
  const [printPositions, setPrintPositions] = useState([]);
  
  // Стан для оброблених документів
  const [processedDocuments, setProcessedDocuments] = useState([]);

  const { selectedDocument, selectDocument, clearDocument } = useDocument();

  useEffect(() => {
    fetchPackagesData();  }, []);

  const fetchPackagesData = async () => {
    try {
      setLoading(true);
      setError('');

      // Завантажуємо основні пакети та оброблені документи паралельно
      const [packagesResponse, processedResponse] = await Promise.all([
        getPackages(),
        getProcessedDocuments()
      ]);

      // Зберігаємо список оброблених документів
      let processedDocsList = [];
      if (processedResponse.success && processedResponse.documents) {
        processedDocsList = processedResponse.documents;
        setProcessedDocuments(processedDocsList);
      }

      if (packagesResponse.success && packagesResponse.packages) {
        setRawPackages(packagesResponse.packages);
        updatePackagesData(expandedPackages, packagesResponse.packages);      } else {
        setRawPackages([]);
        setPackagesData([]);
      }
    } catch (err) {
      console.error('Помилка завантаження пакетів даних:', err);
      setError('Помилка завантаження даних: ' + (err.message || 'Невідома помилка'));
    } finally {
      setLoading(false);
    }
  };

  const updatePackagesData = (expandedSet, packages = rawPackages) => {
    const processedPackages = [];
    
    packages.forEach(pkg => {      // Додаємо пакет як основний рядок
      const packageRow = {
        id: `package_${pkg.ИдентификаторПакета}`,
        type: 'package',
        packageId: pkg.ИдентификаторПакета || 'Не вказано',
        packageDate: formatDate(pkg.ДатаФормирования),
        operation: pkg.ВидОперации || 'Не вказано',
        packageNumber: pkg.НомерПакета || 'Не вказано',
        documentsCount: pkg.Документы ? pkg.Документы.length : 0,
        rawPackage: pkg,
        isExpanded: expandedSet.has(pkg.ИдентификаторПакета)
      };
      
      processedPackages.push(packageRow);
        // Якщо пакет розгорнуто, додаємо його документи як дочірні рядки
      if (expandedSet.has(pkg.ИдентификаторПакета) && pkg.Документы) {
        pkg.Документы.forEach(doc => {
          const documentRow = {
            id: `document_${pkg.ИдентификаторПакета}_${doc.ДокументНомер}`,
            type: 'document',
            packageId: pkg.ИдентификаторПакета,
            documentType: doc.ДокументВид || 'Не вказано',
            documentNumber: doc.ДокументНомер || 'Не вказано',
            documentDate: formatDate(doc.ДокументДата),
            positionsCount: doc.Позиции ? doc.Позиции.length : 0,
            status: doc.ДокументСтатус || 'Новий',
            rawDocument: doc,
            rawPackage: pkg,
            isChild: true
          };
          
          processedPackages.push(documentRow);
        });
      }
    });

    setPackagesData(processedPackages);
  };  const formatDate = (dateString) => {
    if (!dateString) return 'Не вказана';
    try {
      return new Date(dateString).toLocaleString('uk-UA');
    } catch {
      return 'Неправильна дата';
    }
  };

  const handleTogglePackage = (packageId) => {
    const newExpanded = new Set(expandedPackages);
    if (newExpanded.has(packageId)) {
      newExpanded.delete(packageId);
    } else {
      newExpanded.add(packageId);
    }
    setExpandedPackages(newExpanded);
    // Оновлюємо дані таблиці з новим станом розгорнутих пакетів
    updatePackagesData(newExpanded);
  };  const handleSelectDocument = (row) => {
    // Перевіряємо, чи є документ серед оброблених
    const isProcessed = processedDocuments.some(processedDoc => 
      processedDoc.ДокументНомер === row.rawDocument.ДокументНомер &&
      processedDoc.ДокументДата === row.rawDocument.ДокументДата
    );

    let adaptedDocument, adaptedPositions;

    if (isProcessed) {
      // Якщо документ оброблено, використовуємо дані з обробленого документа
      const processedDoc = processedDocuments.find(processedDoc => 
        processedDoc.ДокументНомер === row.rawDocument.ДокументНомер &&
        processedDoc.ДокументДата === row.rawDocument.ДокументДата
      );

      adaptedDocument = {
        id: processedDoc.ДокументНомер,
        filename: processedDoc.ДокументНомер,
        created: processedDoc.ДокументДата,
        ДокументДата: processedDoc.ДокументДата,
        ДокументВид: processedDoc.ДокументВид,
        documentType: processedDoc.ДокументВид,
        size: JSON.stringify(processedDoc).length,
        data: processedDoc
      };

      adaptedPositions = (processedDoc.Позиции || []).map(pos => ({
        id: pos.Код,
        article: pos.Код,
        name: pos.Наименование,
        barcode: pos.Штрихкод || pos.Код,
        plan: Number(pos.КоличествоПлан) || 0,
        fact: Number(pos.КоличествоФакт) || 0,
        reserve: Number(pos.КоличествоРезерв) || 0,
        status: pos.СтатусПозиции || '',
        category: pos.Категория || '',
        subcategory: pos.Подкатегория || '',
        brand: pos.ТорговаяМарка || '',
        warehouse: pos.Склад || ''
      }));    } else {
      // Якщо документ не оброблено, використовуємо вихідні дані
      adaptedDocument = {
        id: row.rawDocument.ДокументНомер,
        filename: row.rawDocument.ДокументНомер,
        created: row.rawDocument.ДокументДата,
        ДокументДата: row.rawDocument.ДокументДата,
        ДокументВид: row.rawDocument.ДокументВид,
        documentType: row.rawDocument.ДокументВид,
        size: JSON.stringify(row.rawDocument).length,
        data: row.rawDocument
      };

      adaptedPositions = (row.rawDocument.Позиции || []).map(pos => ({
        id: pos.Код,
        article: pos.Код,
        name: pos.Наименование,
        barcode: pos.Штрихкод || pos.Код,
        plan: Number(pos.КоличествоПлан) || 0,
        fact: Number(pos.КоличествоФакт) || 0,
        reserve: Number(pos.КоличествоРезерв) || 0,
        status: pos.СтатусПозиции || '',
        category: pos.Категория || '',
        subcategory: pos.Подкатегория || '',
        brand: pos.ТорговаяМарка || '',
        warehouse: pos.Склад || ''
      }));
    }

    selectDocument(adaptedDocument, adaptedPositions, isProcessed);
  };

  const handleToggleDocument = (row) => {
    const selected = isDocumentSelected(row.documentNumber);
    if (selected) {
      clearDocument();
    } else {
      handleSelectDocument(row);
    }
  };
  const isDocumentSelected = (documentNumber) =>
      selectedDocument && selectedDocument.filename === documentNumber;

  // Функція для розділення пакета на окремі документи
  const handleSplitPackage = async (packageId) => {
    try {
      const confirmed = window.confirm(
        `Ви впевнені, що хочете розділити пакет "${packageId}" на окремі документи?`
      );
      
      if (!confirmed) return;

      console.log('Починаємо розділення пакета:', packageId);
      
      const result = await splitPackage(packageId);
      
      if (result.success) {
        alert(`Пакет успішно розділено на ${result.documentsProcessed} документів.\nДокументи збережено в папці для обробки.`);
        console.log('Результат розділення:', result);
      } else {
        throw new Error(result.error || 'Невідома помилка при розділенні пакета');
      }
    } catch (error) {
      console.error('Помилка розділення пакета:', error);
      alert(`Помилка розділення пакета: ${error.message}`);
    }
  };

  // Обробники для вікна товарів
  const handleRowClick = (row) => {
    if (row.type === 'package') {
      // Для пакетів - розгортаємо/згортаємо
      handleTogglePackage(row.packageId);
    } else if (row.type === 'document') {
      // Для документів - відкриваємо вікно товарів
      setSelectedDocumentForProducts(row.rawDocument);
      setShowProductsWindow(true);
    }
  };
  const handleCloseProductsWindow = () => {
    setShowProductsWindow(false);
    setSelectedDocumentForProducts(null);  };  // Обробники для вікна друку
  const handleOpenPrint = (printData = [], documentData = null, positions = []) => {
    console.log('DataPacketsSection handleOpenPrint викликано з параметрами:', { printData, documentData, positions });
    console.log('documentData детально:', documentData);
    console.log('positions детально:', positions);
    
    // Адаптуємо дані документа для друку
    let adaptedDocumentData = null;
    if (documentData) {
      adaptedDocumentData = {
        ...documentData,        // Додаємо поля, які очікує DocumentPrint
        filename: documentData.ДокументНомер || documentData.documentNumber || documentData.filename || 'Документ',
        created: documentData.ДокументДата || documentData.created || new Date().toISOString(),
        size: JSON.stringify(documentData).length,
        selectedAt: new Date().toISOString(),
        // Зберігаємо оригінальні поля 1С
        ДокументНомер: documentData.ДокументНомер || documentData.documentNumber || documentData.filename,
        ДокументДата: documentData.ДокументДата || documentData.created,
        ДокументВид: documentData.ДокументВид || documentData.documentType || 'Не вказано'
      };
    }
      // Адаптуємо позиції для друку
    const adaptedPositions = positions.map(pos => ({
      ...pos,
      // Додаємо поля, які очікує DocumentPrint
      id: pos.Код || pos.article || pos.id,
      article: pos.Код || pos.article || '',
      name: pos.Наименование || pos.name || '',
      barcode: pos.Штрихкод || pos.barcode || pos.Код || pos.article || '',  
      plan: Number(pos.КоличествоПлан || pos.plan || 0),
      fact: Number(pos.КоличествоФакт || pos.fact || 0),
      // Зберігаємо оригінальні поля 1С
      Код: pos.Код || pos.article || '',
      Наименование: pos.Наименование || pos.name || '',
      Штрихкод: pos.Штрихкод || pos.barcode || '',
      КоличествоПлан: Number(pos.КоличествоПлан || pos.plan || 0),
      КоличествоФакт: Number(pos.КоличествоФакт || pos.fact || 0)
    }));
    
    console.log('Адаптовані дані для друку:', {
      adaptedDocumentData,
      adaptedPositions
    });
    
    setPrintDocument(adaptedDocumentData);
    setPrintPositions(adaptedPositions);
    setShowPrintWindow(true);
  };

  const handleClosePrintWindow = () => {
    setShowPrintWindow(false);
    setPrintDocument(null);
    setPrintPositions([]);
  };
  const columns = [    {
      key: 'expandButton',
      title: '',
      width: '40px',
      textAlign: 'center',
      render: (_, row) => {
        if (row.type === 'package') {
          return (
            <div
              style={{
                cursor: 'pointer',
                fontSize: '16px',
                color: '#9c27b0',
                fontWeight: 'bold'
              }}
              title={row.isExpanded ? 'Згорнути пакет' : 'Розгорнути пакет'}
            >
              {row.isExpanded ? '−' : '+'}
            </div>
          );        }        // Для документів показуємо статус
        if (row.type === 'document') {
          // Перевіряємо, чи є документ обробленим
          const isProcessed = processedDocuments.some(processedDoc => 
            processedDoc.ДокументНомер === row.documentNumber
          );
          
          const currentStatus = isProcessed ? 'Оброблено' : (row.status || 'Новий');
            // Визначаємо іконку статусу
          let statusIcon;
          switch (currentStatus) {
            case 'Новий':
            case '':
              statusIcon = '🟡'; // Жовте коло
              break;
            case 'До обробки':
              statusIcon = '🔵'; // Синє коло
              break;
            case 'Оброблено':
              statusIcon = '🟢'; // Зелене коло
              break;
            default:
              statusIcon = '🟡';
          }
          
          return (
            <div
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                margin: '0 auto',
                marginLeft: '20px'
              }}
              title={`Статус документа: ${currentStatus}`}
            >
              {statusIcon}
            </div>
          );
        }
        
        return '';
      }
    },    {
      key: 'packageId',
      title: 'Ідентифікатор пакета',
      width: '200px',
      sortable: true,
      filterable: true,
      render: (value, row) => {
        if (row.type === 'package') {
          return <span style={{ fontWeight: 600, color: '#7b1fa2' }}>{value}</span>;
        } else {
          return <span style={{ fontSize: '12px', color: '#999', marginLeft: '20px' }}>{row.documentType}</span>;
        }
      }
    },    {
      key: 'operation',
      title: 'Операція',
      width: '120px',
      sortable: true,
      filterable: true,
      render: (value, row) => {
        if (row.type === 'package') {
          return <span style={{ fontWeight: 500, color: '#333' }}>{value}</span>;
        } else {
          return <span style={{ fontWeight: 500, color: '#1976d2', marginLeft: '20px' }}>{row.documentNumber}</span>;
        }
      }
    },
    {
      key: 'packageDate',
      title: 'Дата',
      width: '150px',
      sortable: true,
      render: (value, row) => {
        const date = row.type === 'package' ? row.packageDate : row.documentDate;
        return <span style={{ fontSize: '13px' }}>{date}</span>;
      }
    },    {
      key: 'documentsCount',
      title: 'Кількість',
      width: '100px',
      sortable: true,
      textAlign: 'center',
      render: (value, row) => {
        if (row.type === 'package') {
          return <span style={{ fontWeight: 500, color: '#666' }}>{value} док.</span>;
        } else {
          return <span style={{ fontWeight: 500, color: '#666', marginLeft: '20px' }}>{row.positionsCount} поз.</span>;
        }
      }    },    {
      key: 'action',
      title: 'Дія',
      width: '120px',
      textAlign: 'center',
      render: (_, row) => {
        if (row.type === 'package') {
          return (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleSplitPackage(row.packageId);
              }}
              style={{
                padding: '4px 8px',
                background: '#ff9800',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                cursor: 'pointer',
                fontSize: 11,
                fontWeight: 500
              }}
              title="Розділити пакет на окремі документи"
            >
              📋 Розділити
            </button>
          );
        } else if (row.type === 'document') {
          const selected = isDocumentSelected(row.documentNumber);
          return (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleToggleDocument(row);
              }}
              style={{
                padding: '4px 8px',
                background: selected ? '#f44336' : '#4caf50',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                cursor: 'pointer',
                fontSize: 11,
                fontWeight: 500,
                marginLeft: '20px'
              }}
              title={selected ? 'Скасувати вибір' : 'Вибрати як поточний документ'}
            >
              {selected ? '✖' : '✓'}
            </button>
          );
        }
        return '';
      }
    }
  ];
  if (loading) {
    return (
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color: '#666' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 32, marginBottom: 16 }}>📦</div>
          <div>Завантаження пакетів даних...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 20,
          color: '#d32f2f'
        }}
      >        <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
        <div style={{ fontSize: 18, marginBottom: 10 }}>Помилка завантаження</div>
        <div style={{ fontSize: 14, textAlign: 'center' }}>{error}</div>
        <button
          onClick={fetchPackagesData}
          style={{
            marginTop: 15,
            padding: '8px 16px',
            background: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: 4,
            cursor: 'pointer'
          }}
        >
          Повторити
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        padding: window.innerWidth < 768 ? '8px 0' : '16px',
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: window.innerWidth < 768 ? '8px' : '16px',
          margin: window.innerWidth < 768 ? '0 8px 8px 8px' : '0 0 16px 0',
          padding: window.innerWidth < 768 ? '8px' : '12px',
          background: 'linear-gradient(135deg, #f3e5f5 0%, #9c27b0 100%)',
          border: window.innerWidth < 768 ? 'none' : '1px solid #9c27b0',
          borderRadius: window.innerWidth < 768 ? '0' : '8px',
          boxShadow: window.innerWidth < 768 ? 'none' : '0 2px 6px rgba(156, 39, 176, 0.2)',
          flexShrink: 0
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ fontSize: '32px', marginRight: '12px' }}>📦</span>
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: '20px',
                fontWeight: '600',
                color: '#7b1fa2'
              }}
            >
              Data Packets
            </h2>
            <div style={{
              fontSize: '14px',
              color: '#8e24aa',
              fontWeight: '500',
              marginTop: '2px'
            }}>
              Пакети даних • {packagesData.filter(row => row.type === 'package').length} пакетів
            </div>
          </div>
        </div>

        <button
          onClick={fetchPackagesData}
          style={{
            padding: '4px 8px',
            background: 'rgba(255,255,255,0.8)',
            border: '1px solid #9c27b0',
            borderRadius: 4,
            cursor: 'pointer',
            fontSize: '27px'
          }}
          title="Оновити список"
        >
          ⟲
        </button>
      </div>

      {/* Контентна область: таблиці/гриди всередині повинні самі скролитися */}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >        <DataTable
          data={packagesData}
          columns={columns}
          options={{
            filterable: true,
            sortable: true,
            showRowNumbers: false,
            striped: true,
            height: '100%',
            onRowClick: handleRowClick
          }}
        />
      </div>      {/* Вікно товарів */}
      {showProductsWindow && selectedDocumentForProducts && (
        <WindowProducts
          isOpen={showProductsWindow}
          document={selectedDocumentForProducts}
          positions={selectedDocumentForProducts.Позиции || []}
          onClose={handleCloseProductsWindow}
          onOpenPrint={handleOpenPrint}
        />
      )}

      {/* Вікно друку */}
      {showPrintWindow && (
        <WindowPrint
          onClose={handleClosePrintWindow}
          documentData={printDocument}
          positions={printPositions}
        />
      )}
    </div>
  );
}
